import { Segmented } from './Segmented'

export const RANGES = { '7d': 7, '30d': 30, '90d': 90, '1y': 365 } as const
export type RangeKey = keyof typeof RANGES

export function rangeFrom(range: RangeKey): string {
	return new Date(Date.now() - RANGES[range] * 86_400_000).toISOString()
}

export function RangePicker({ value, onChange }: { value: RangeKey; onChange(v: RangeKey): void }) {
	return (
		<Segmented
			label="Time range"
			value={value}
			options={(Object.keys(RANGES) as RangeKey[]).map((r) => ({ value: r, label: r }))}
			onChange={onChange}
		/>
	)
}
